import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import * as actions from '../actions';

import Breadcrumb from '../components/Breadcrumb/Breadcrumb';

const mapStateToProps = ({ auth: { profile } }) => ({ profile });

const mapDispatchToProps = dispatch => bindActionCreators(actions, dispatch);

const BreadcrumbContainer = connect(mapStateToProps, mapDispatchToProps)(Breadcrumb);

export default BreadcrumbContainer;



// WEBPACK FOOTER //
// ./src/containers/BreadcrumbContainer.js